import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Button, Layout, Space, Typography} from 'antd';
import YouTube from 'react-youtube';

import VideoPageFeatureMenu from '../VideoPageFeatureMenu';
import { postVideoWatchData } from '../../../actions/user';
import { setVideoTimestamp, setSkipToVideoTimestamp } from '../../../actions/videoControl';



const {Content} = Layout;
const { Text, Title } = Typography;
var BASE_RATE = 10000;

const PLAYER_OPTIONS = {
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      rel: 0
    },
};

class YouTubePlayer extends Component {
    
    constructor(props){
        super(props)
        this.state = {
            trackingInterval: null,
            transcriptTimeout: null,
            playerRef: null
        }
    }

    PLAYING = 1;
    
    componentWillUnmount = () => {
        if(this.state.trackingInterval){
            clearInterval(this.state.trackingInterval)
        }
        if(this.state.transcriptTimeout){
            clearTimeout(this.state.transcriptTimeout)
        }
        this.props.setVideoTimestamp(0)
        this.setState({trackingInterval: null, transcriptTimeout: null})
    }
    
    componentDidUpdate(prevProps){
        if(prevProps.skipToVideoTimestamp !== this.props.skipToVideoTimestamp && this.props.skipToVideoTimestamp !== null) {
            let element = document.getElementById('video-show-page');
            element.scrollIntoView({behavior: "smooth", block: "start"});
            this.seekToVideoTimestamp(this.props.skipToVideoTimestamp)
            this.props.setSkipToVideoTimestamp(null)
        }
    }

    track = () => {
        var currentTime = this.state.playerRef.getCurrentTime()
        var playbackRate = this.state.playerRef.getPlaybackRate()
        var pollRate = BASE_RATE
        this.props.postVideoWatchData(this.props.collection.id, this.props.module.id, this.props.video.id, currentTime, pollRate, playbackRate)
    }


    clearAllIntervals = () => {
        if(this.state.trackingInterval){
            clearInterval(this.state.trackingInterval)
        }
        if(this.state.transcriptTimeout){
            clearTimeout(this.state.transcriptTimeout)
        }
        this.setState({trackingInterval: null, transcriptTimeout: null})
    }
    handleOnPause = () => {
        this.clearAllIntervals()
    }
    
    scrollToNextParagraph = (currentTime, currentElement) => {
        var transcriptDiv = document.getElementById('transcript-tab-content');
        var nextElement = currentElement.nextSibling;
        if(nextElement){
            var startTime = nextElement.getAttribute('data-start-time');
            var endTime = nextElement.getAttribute('data-end-time');
            var paragraphFlag = nextElement.getAttribute('data-paragraph-flag');
    
            if(startTime <= currentTime && endTime > currentTime && paragraphFlag === "true"){
                transcriptDiv.scrollTop = nextElement.offsetTop
            }
        }
    }
    updateVideoTimestamp = () => {
         
        var currentTime = this.state.playerRef.getCurrentTime()
        var playbackRate = this.state.playerRef.getPlaybackRate()
        if(this.props.transcript.length > 0){
           
            var currentElement = document.getElementById('highlighted-transcript-segment');
            if(currentElement){
                this.scrollToNextParagraph(currentTime, currentElement);
            }
        }
        this.props.setVideoTimestamp(currentTime)
        var timeout = setTimeout(this.updateVideoTimestamp, (this.props.nextTranscriptUpdate/playbackRate))
        this.setState({transcriptTimeout: timeout})
    }
    
    handleOnPlay = () => {
        if(this.state.trackingInterval){
            clearInterval(this.state.trackingInterval)
        }
        if(this.state.transcriptTimeout){
            clearTimeout(this.state.transcriptTimeout)
        }
        this.updateVideoTimestamp()
        var newTrackingInterval = setInterval(this.track, BASE_RATE)
        this.setState({trackingInterval: newTrackingInterval})
    }

    handleOnReady = (event) => {
        this.setState({playerRef: event.target})
        if(this.props.customStartTime) {
            event.target.seekTo(this.props.customStartTime)
            this.props.setVideoTimestamp(this.props.customStartTime)
        }
    }

    seekToVideoTimestamp = (timestamp) => {
        this.state.playerRef.seekTo(timestamp)
        this.props.setVideoTimestamp(timestamp)
        if (this.state.playerRef.getPlayerState !== this.PLAYING){
            this.state.playerRef.playVideo();
        }
    }
    seekOnTranscriptClick = (targetElement, timestamp) => {
        var transcriptDiv = document.getElementById('transcript-tab-content');
        transcriptDiv.scrollTop = targetElement.offsetTop

        this.seekToVideoTimestamp(timestamp)
    }

    pausePlayer = () => {
        console.log(this.state.playerRef)
        this.state.playerRef.pauseVideo()
    }

    render(){
        return <>
            <Content id="video-content-wrapper">
           

                <div id="video-wrapper">
                    <YouTube videoId={this.props.video.embedId} height="1080" width="1920"
                            opts={PLAYER_OPTIONS}
                            onPause={this.handleOnPause} 
                            onPlay={this.handleOnPlay}
                            onReady={this.handleOnReady}
                            onEnd={this.clearAllIntervals}
                            onError={this.clearAllIntervals}
                    />
                </div>
            </Content>
            <VideoPageFeatureMenu pauseVideo={this.pausePlayer} seekOnTranscriptClick={this.seekOnTranscriptClick} collapsedTranscript={this.props.collapsedTranscript}  seekToVideoTimestamp={this.seekToVideoTimestamp}/>
        </>
    }
}

const mapStateToProps = (state) => {
    return {
        nextTranscriptUpdate: state.videoControlReducer.nextTranscriptUpdate,
        skipToVideoTimestamp: state.videoControlReducer.skipToVideoTimestamp,
        transcript: state.collectionReducer.transcript
    }
}

export default connect(mapStateToProps, {postVideoWatchData, setSkipToVideoTimestamp, setVideoTimestamp})(YouTubePlayer);